import { render } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=b6fb1210"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__